import { render } from "./ExportForBlender.vue?vue&type=template&id=359f140a"
import script from "./ExportForBlender.vue?vue&type=script&lang=js"
export * from "./ExportForBlender.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__